import React from 'react'
import { BasicSelector , MwInputText, MwSelector, MwSwitch, MwTextArea } from '../../ui';
import FormLangBar from '../../FormLangBar';
import { useTranslation } from 'react-i18next';
import {
    PRODUCT_FORM_SECTION_CLASS,
    PRODUCT_OPTION_LABEL_CLASS,
    PRODUCT_OPTION_ROW_CLASS,
} from '../productUi';

const CategoryForm = ({
    categories,
    currentLangList,
    formLang,
    setFormLang,
    errors,
    categoryParent,
    setCategoryParent,
    categoryClasses,
    categoryClass,
    setCategoryClass,
    categoryClassLabel,
    categoryName,
    setCategoryName,
    categoryDesc,
    setCategoryDesc,
    categoryMetaKeywords,
    setCategoryMetaKeywords,
    categoryMetaDesc,
    setCategoryMetaDesc,
    isShowOnWebsite,
    setIsShowOnWebsite,
    isActive,
    setIsActive,
    categoryCode,
    setCategoryCode
}) => {
    const [t] = useTranslation('global')
    return (
        <form className='space-y-4'>
            <div className={PRODUCT_FORM_SECTION_CLASS}>
                <MwInputText
                    label={t('product.category_code_label')}
                    placeholder={t('product.category_code_label')}
                    id='categoryCode' 
                    value={categoryCode}
                    invalid={!!errors[`categoryCode`] }
                    invalidMsg={errors[`categoryCode`]}
                    onChange={(e)=>setCategoryCode(e.target.value)}
                />
                <div id='categoryType' className='mt-4 flex flex-wrap items-center justify-between gap-4'>
                    <label className='text-xs font-medium text-[#251658]'>{t('product.categoryType')}</label>
                    <div className='flex gap-7 text-sm text-slate-600'>
                        <div id='categoryParentMain'>
                            <input id='isActiveMain' type="radio" checked={categoryParent==='main'} onChange={()=>setCategoryParent('main')} value={categoryParent}/>
                            <label htmlFor="isActiveMain" className='px-1'>{t('product.main_category')}</label>
                        </div>
                        <div id='categoryParentbranch'>
                            <input id='isActiveSub' type="radio" checked={categoryParent !== 'main'} onChange={()=>setCategoryParent('sub')} value={categoryParent}/> 
                            <label htmlFor="isActiveSub" className='px-1'>{t('product.sub_category')}</label> 
                        </div>
                    </div>
                </div>
                { categoryParent !== 'main' && (
                    <div className='relative mt-4 z-50'>
                        <MwSelector 
                            className={`${errors.categoryParent ? 'border rounded border-red-500' : ''}`}
                            label={t('product.main_category_')}
                            withAddNew={false}
                            _data={categories} 
                            dataType='labelValue'
                            selectedItem={categoryParent}
                            initalValue={t('product.select_main_category')}
                            setSelectedItem={(newValue) => setCategoryParent(newValue)}
                        />
                        {errors.categoryParent && <div className='px-2 pt-1 text-xs text-red-400'>{errors.categoryParent}</div>}
                    </div>
                )}
                <div className='relative mt-4'>
                    <label className='mb-1 block px-1 text-xs font-medium text-[#251658]'>{t('product.category_class_label')}</label>
                    <BasicSelector 
                        className={`${errors.categoryClass ? 'border-red-500' : ''}`}
                        listItem={categoryClasses}
                        label={t('product.select_category_class')}
                        defaultValue={categoryClassLabel}
                        size='lg'
                        onSelected={(newValue) => setCategoryClass(newValue.value)}
                    />
                    {errors.categoryClass && <div className='px-2 pt-1 text-xs text-red-400'>{errors.categoryClass}</div>}
                </div>
            </div>

            <div className='flex flex-col'>
                <FormLangBar currentLangList={currentLangList} formLang={formLang} setFormLang={setFormLang} />
                { currentLangList.map((lang) => (
                    <div key={lang.langCode} className={`${PRODUCT_FORM_SECTION_CLASS} ${formLang === lang?.langCode ? 'block' : 'hidden'}`}>
                        <MwInputText
                            label={`${t('product.category_name_label')} (${lang?.langName})`}
                            id={`categoryName${lang?.langCode}`} 
                            placeholder={`${t('product.category_name_label')} (${lang?.langName})`}
                            value={categoryName[lang?.langCode]}
                            invalid={!!errors[`categoryName.${lang?.langCode}`]}
                            invalidMsg={errors[`categoryName.${lang?.langCode}`]}
                            onChange={(e)=>{
                                setCategoryName({...categoryName, [lang?.langCode]:e.target.value});
                            }}
                        />
                        <div className='mt-3'>
                            <MwTextArea
                                id={`categoryDesc${lang?.langCode}`}
                                label={`${t('product.category_desc_placeholder')} (${lang.langName})`}
                                value={categoryDesc[lang?.langCode]}
                                placeholder={`${t('product.category_desc_placeholder')} (${lang.langName})`}
                                rows={4}
                                onChange={(e ) => setCategoryDesc({...categoryDesc,[lang?.langCode]:e.target.value})}
                            />
                        </div>
                        <div className='mt-3'>
                            <MwTextArea
                                id={`categoryMetaKeywords${lang?.langCode}`}
                                label={`${t('product.seo_keywords_placeholder')} (${lang.langName})`}
                                value={categoryMetaKeywords[lang?.langCode]}
                                placeholder={`${t('product.seo_keywords_placeholder')} (${lang.langName})`}
                                rows={4}
                                onChange={(e ) => setCategoryMetaKeywords({...categoryMetaKeywords,[lang?.langCode]:e.target.value})}
                            />
                        </div>
                        <div className='mt-3'>
                            <MwTextArea
                                id={`categoryMetaDesc${lang?.langCode}`}
                                label={`${t('product.seo_desc_placeholder')} (${lang.langName})`}
                                value={categoryMetaDesc[lang?.langCode]}
                                placeholder={`${t('product.seo_desc_placeholder')} (${lang.langName})`}
                                rows={4}
                                onChange={(e ) => setCategoryMetaDesc({...categoryMetaDesc,[lang?.langCode]:e.target.value})}
                            />
                        </div>
                    </div>
                )) }
            </div>

            <div id='OptionsBock' className='flex flex-col gap-3'>
                <div className={PRODUCT_OPTION_ROW_CLASS}>
                    <label className={PRODUCT_OPTION_LABEL_CLASS}>{t('product.website_visibility')}</label>
                    <MwSwitch custKey='isActive' isActive={isShowOnWebsite} setIsActive={setIsShowOnWebsite} onChangeSwitch={()=> setIsShowOnWebsite(!isShowOnWebsite)} />
                </div>
                <div className={PRODUCT_OPTION_ROW_CLASS}>
                    <label className={PRODUCT_OPTION_LABEL_CLASS}>{t('product.activation_status')}</label>
                    <MwSwitch custKey='isActive' isActive={isActive} setIsActive={setIsActive} onChangeSwitch={() => setIsActive(!isActive)} />
                </div>
            </div>
        </form>
    )
}

export default CategoryForm
